﻿(() => {
    var button = document.querySelector("#cookieConsent button[data-cookie-string]") as HTMLElement;

    if (button !== null)
        button.addEventListener("click", (e) => {
            document.cookie = button.dataset.cookieString ?? '';
        }, false);
})();
